export enum PropertyUsage {
  RESIDENTIAL = 'RESIDENCIAL',
  COMMERCIAL = 'COMERCIAL',
  MIXED = 'MISTO'
}
